<template>
    <div>
        <div class="input-button-group">
            <el-input placeholder="请输入账号" style="width: 200px;" v-model="userName"></el-input>
            <el-button @click="handleSearch" class="add-button" type="primary">搜索</el-button>
             <el-button @click="deletedata" class="add-button" type="primary">批量删除</el-button>
            
            <!-- 将模板按钮移到右侧 -->
            <div style="margin-left: 300px;">
               
                <el-button class="add-button" @click="downloadTemplate('student')">学生模板</el-button>
                <el-button class="add-button" @click="downloadTemplate('teacher')">教师模板</el-button>
            </div>
             <el-upload class="upload-demo" :action="updateurl+'?updateSupport=' + updateSupport" :auto-upload="false" 
                :on-change="handleFileChange" :show-file-list="false" :headers="headers">
                <el-button class="add-button">导入用户</el-button>
            </el-upload>
            
        </div>
    </div>
</template>
<style scoped>
.input-button-group {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.add-button {
    background-color: #ff69b4;
    /* 玫红色按钮背景 */
    color: white;
    border: none;
    margin-left: 10px;
    border-radius: 4px;
}

.add-button:hover {
    background-color: #ff1493;
    /* 深玫红色按钮悬停背景 */
}
</style>
<script>
// import * as XLSX from 'xlsx'
// import { xlsx } from '@/utils/xlsx';
// import { addUser } from '@/api/system/user';
// import dayjs from 'dayjs';
// import utc from 'dayjs/plugin/utc';
// import timezone from 'dayjs/plugin/timezone';
// import { Loading } from 'element-ui';
import {importDataAll} from '@/api/system/user'
import { getToseck } from '@/utils/toseck';
import store from '@/store';
export default {
    data() {
        return {
        updateurl: process.env.VUE_APP_BASE_API + "/system/user/importDataAll",
        headers: {
            'Authorization': 'Bearer ' +getToseck()
        },
        updateSupport:0,
        userName:'',
        };
    },
    methods: {
        deletedata(){
        this.$confirm('确定删除选中用户吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.state.delete=true;
        }).catch(() => {
           
        })},
        handleSearch() {
                if (this.userName == '' || this.userName == null) {
                    store.commit('setname', 'ALL');
                    return;
                }
                store.commit('setname', this.userName);
                // 触发搜索操作
                this.$emit('search', this.userName);
    },
    downloadTemplate(type) {
            // 假设模板文件放在public/templates目录下
            const fileName = type === 'student' ? '学生模板.xlsx' : '教师模板.xlsx';
            const fileUrl = `/templates/${fileName}`;
            
            // 创建隐藏的a标签触发下载
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // 或者使用window.open方式
            // window.open(fileUrl, '_blank');
        },
    // dialogFormVisible(visible) {
    //   store.commit('setDialogFormVisible', visible);
    // },
       
        async handleFileChange(file) {
            let fileList = file.raw;
            if (!fileList) {
                this.$message.error('请选择文件');
                return;
            }
            const formdata = new FormData();
            formdata.append('file', fileList);
            importDataAll(formdata).then(res => {
                if (res.code === 200) {
                    this.$message.success('导入成功');
                    // window.location.reload(); 
                }
                else{
                    this.$message.error('导入失败');
                }
            })
            // try {
            //     const xsl = await xlsx(fileList)
            //     const xslread = XLSX.read(xsl, { type: 'binary' })
            //     const xslsheets = xslread.Sheets[xslread.SheetNames[0]]
            //     const data = XLSX.utils.sheet_to_json(xslsheets)
                
            //     // ... existing code ...
            //     const filemap = {
            //         "用户序号": "userId",
            //         "用户名称": "nickName",
            //         "用户性别": "sex",
            //         "帐号状态": "status",
            //         "用户邮箱": "email",
            //         "家庭住址": "address",
            //         "手机号码": "phonenumber",
            //         "最后登录IP": "loginIp",
            //         "最后登录时间": "loginDate",
            //         "部门名称": "deptName",
            //         "部门负责人": "leader",
            //         "登录名称": "userName",
            //         "密码": "password",
            //     };

            //     dayjs.extend(utc);
            //     dayjs.extend(timezone);

            //     const newdata = [];
            //     data.forEach((item) => {
            //         const newItem = {};
            //         for (const key in item) {
            //             if (Object.hasOwnProperty.call(item, key)) {
            //                 let element = item[key];
            //                 if (key === '最后登录时间') {
            //                     // 将日期字符串转换为后端期望的格式
            //                     element = dayjs(element).utc().format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
            //                 }
            //                 if (key === '帐号状态') {
            //                     element = element === '正常' ? '0' : '1'; 
            //                 }
            //                 const newKey = filemap[key] || key;
            //                 newItem[newKey] = element;
            //             }
            //         }
            //         newdata.push(newItem);
            //     });
            //     console.log(newdata);
            //     console.log(xslsheets);
            //     const load = Loading.service({
            //         lock: true,
            //         text: '导入中...',
            //         spinner: 'el-icon-loading',
            //     })
            //     let r = null;
            //     for (let i = 0; i < newdata.length; i++) {
            //         try {
            //             r = await addUser(newdata[i]);
            //         }
            //         catch (error) {
            //             console.log(error);
            //             // 处理错误
            //         }
            //     }
            //     load.close()
            //     if (r.code === 200) {
            //         this.$message.success('导入成功');
            //     }
            //     else {
            //         this.$message.error('导入失败');
            //         console.log(r);
            //     }
            // } catch (error) {
            //     console.log(error);
            //     // 修改错误信息获取方式
            //     this.$message.error(error.message || '导入失败');
            // }
        },
        
    }
}
</script>
